import { createAction } from '@sde/widgets-core/src/redux/helpers/createAction';
import { SET_TUTORIAL_ACTIVE, SET_TRAINING_TIPS_ACTIVE } from './constants';

export const setTutorialActive = (isActive) => {
  return createAction({
    type: SET_TUTORIAL_ACTIVE,
    payload: isActive,
  });
};

export const setTrainingTipsActive = (isActive) => {
  return createAction({
    type: SET_TRAINING_TIPS_ACTIVE,
    payload: isActive,
  });
};
